import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { DataTable } from '@/components/ui/table/data-table';
import useMembers from '@/hooks/useMembers';

import { createColumns } from './columns';
import { LanguageModel } from '../../types';

interface LanguageModelsTableProps {
  languageModels: LanguageModel[];
  isLoading: boolean;
  canWrite: boolean;
  canDelete: boolean;
  onEdit: (model: LanguageModel) => void;
  onDelete: (model: LanguageModel) => void;
  onToggleEnabled: (model: LanguageModel) => void;
  activeRowId?: string;
}

export const LanguageModelsTable = ({
  languageModels,
  isLoading,
  canWrite,
  canDelete,
  onEdit,
  onDelete,
  onToggleEnabled,
  activeRowId,
}: LanguageModelsTableProps) => {
  const { t } = useTranslation();
  const { getMember } = useMembers();

  const columns = useMemo(
    () => createColumns({ onEdit, onDelete, onToggleEnabled, getMember, canWrite, canDelete }),
    [onEdit, onDelete, onToggleEnabled, getMember, canWrite, canDelete]
  );

  return (
    <DataTable.Root
      fill
      className="min-h-0 flex-1"
      columns={columns}
      data={languageModels}
      rowCount={languageModels.length}
      isLoading={isLoading}
      resourceName="language-models"
      emptyStateMessage={t('developer_tools.language_models_no_results')}
      getRowId={(row) => row.language_model_id}
      activeRowId={activeRowId}
      onRowClick={onEdit}
      enableRowHover
    >
      <DataTable.Content />
      <DataTable.Pagination />
    </DataTable.Root>
  );
};
